











































































































































































































































































import {Component, Watch} from "vue-property-decorator";
import dataProxy from "../../../services/data-proxy.service";
import {B2BPodatakOsobe, Osoba} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import PregledPodsetnikaOsoba from "@/views/Podsetnici/PregledPodsetnikaOsoba.vue";

declare const $ : any;

@Component({components: {'mf-pregled-podsetnika' : PregledPodsetnikaOsoba}})
export default class PodaciZaposlenog extends mixins(ComponentBaseMixin) {
    osoba = new Osoba();
    b2bPodaci: B2BPodatakOsobe[] = [];
    promeniLozinku = false;
    potvrdaLozinke = "";
    korisnickoIme = null;
    currentTab = 0;

    async created() {
        this.load();
    }

    async load() {
        this.promeniLozinku = false;
        const idZaposlenog = +this.$route.params["id"];
        if (idZaposlenog) {
              const osoba = await this.loadData(() => dataProxy.vratiOsobu(idZaposlenog))();
              setTimeout(() => {
                  this.osoba = osoba;
                  this.korisnickoIme = this.osoba.korisnickoIme;
              }, 500);

        } else {
            this.osoba = new Osoba();
        }
        this.b2bPodaci = await this.loadData(() => dataProxy.vratiB2BPodatkeOsobe(idZaposlenog))();
        this.$nextTick(() => {
            (<any>this.$refs.form).validate();
        });
    };

    @Watch('$route') onRouteChanged() {
        this.load();
    }

    async sacuvaj() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.korisnickoIme = this.osoba.korisnickoIme;
            this.osoba = await this.saveData(() =>
                dataProxy.sacuvajOsobu(this.osoba)
            )();
            this.promeniLozinku = false;
        }
    }

    async obrisiZaposlenog() {
        const yes = await this.confirmationNeeded('da li zelite da obrisete zaposlenog');
        if (yes) {
            await this.deleteData(() => dataProxy.obrisiOsobu(this.osoba.id))();
            this.$router.push({name: 'pregledZaposlenih'})
        }
    }

    async promenaLozinke() {
        this.promeniLozinku = false;
        await this.saveData(() => dataProxy.promeniLozinku(this.osoba.id, this.osoba.lozinka))();
        this.potvrdaLozinke = '';
    }

    novZaposlen() {
        this.korisnickoIme = null;
        if (!this.$route.params.id) {
            this.osoba = new Osoba();
        } else {
            this.$router.push('/podaci-zaposlenog');
        }
    }

    toggleLozinku(index) {
        this.promeniLozinku = true;
        if (this.promeniLozinku == true) {
            this.$nextTick(() => {
                (<HTMLElement>this.$refs.password).focus();
                this.osoba.lozinka = "";
            });
        }
    }

    async sacuvajB2B() {
        this.saveData(() => dataProxy.sacuvajB2BPodatkeOsobe(this.osoba.id, this.b2bPodaci.filter(x => x.vrednost)))();
    }

    otkaziPromenuLozinke() {
        this.promeniLozinku = false;
        this.potvrdaLozinke = '';
    }
}
